import { render, staticRenderFns } from "./EBook.vue?vue&type=template&id=2d7235f2&scoped=true&"
import script from "./EBook.vue?vue&type=script&lang=js&"
export * from "./EBook.vue?vue&type=script&lang=js&"
import style0 from "./EBook.vue?vue&type=style&index=0&id=2d7235f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7235f2",
  null
  
)

export default component.exports